import { useEffect, useRef } from 'react'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { getDefaultStartDate } from 'src/Constants/functions'
import { useGetSubscriptionQuery } from 'src/Redux/subscription-process/subscriptionApi'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

export const useDefaultSpotifyCampaignStartDate = (): void => {
  const { search } = useCustomSearchParams()

  const urlStartDate = search.get('startDate')
  const { data } = useGetSubscriptionQuery()
  const hasActiveOrCanceledSubscription = Boolean(
    data?.status === 'active' || data?.status === 'canceled',
  )

  const { campaignDetails: spotifyCampaignDetails, setStartDate } =
    useSpotifyCampaignStatus()

  const startDateRef = useRef('')

  useEffect(() => {
    if (spotifyCampaignDetails?.start_date) {
      startDateRef.current = String(spotifyCampaignDetails.start_date)
      return
    }

    if (urlStartDate) {
      startDateRef.current = urlStartDate
      return
    }

    if (startDateRef.current) {
      setStartDate(startDateRef.current)
      return
    }

    const defaultStartDate = getDefaultStartDate(
      hasActiveOrCanceledSubscription,
    )
    setStartDate(defaultStartDate)
    startDateRef.current = defaultStartDate
  }, [
    setStartDate,
    spotifyCampaignDetails?.start_date,
    urlStartDate,
    hasActiveOrCanceledSubscription,
  ])
}
